import { cva } from 'class-variance-authority';
import type { LinkColors, LinkSizes } from './types';

export const linkDecoratorVariants = cva('', {
  variants: {
    size: {
      xs: 'size-3',
      sm: 'size-4',
      md: 'size-4',
      lg: 'size-5',
    } satisfies Record<LinkSizes, string>,
    color: {
      brand: 'focus-visible:ring-brand',
      neutral: 'focus-visible:ring-gray',
      error: 'focus-visible:ring-error',
    } satisfies Record<LinkColors, string>,
  },
});

export const linkVariants = cva('decoration-current', {
  variants: {
    size: {
      xs: 'gap-xxs',
      sm: 'gap-xs',
      md: 'gap-xs',
      lg: 'gap-sm',
    } satisfies Record<LinkSizes, string>,
  },
});

export const linkTextVariants = cva('', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-sm',
      lg: 'text-md',
    } satisfies Record<LinkSizes, string>,
    underline: {
      //https://github.com/tailwindlabs/tailwindcss/blob/next/packages/tailwindcss/preflight.css#L95 causing decoration to not apply
      always: '!underline',
      hover: '',
      none: '',
    },
  },
});

export const linkTextColorVariants = cva('', {
  variants: {
    color: {
      brand: '',
      neutral: '',
      error: '',
    } satisfies Record<LinkColors, string>,
    disabled: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    { color: 'brand', disabled: false, className: 'text-[--link-brand-fg]' },
    { color: 'brand', disabled: true, className: 'text-[--link-brand-fg_disabled]' },

    { color: 'neutral', disabled: false, className: 'text-[--link-neutral-fg]' },
    { color: 'neutral', disabled: true, className: 'text-[--link-neutral-fg_disabled]' },

    { color: 'error', disabled: false, className: 'text-[--link-error-fg]' },
    { color: 'error', disabled: true, className: 'text-[--link-error-fg_disabled]' },
  ],
  defaultVariants: {
    disabled: false,
  },
});
